import request from '@/utils/http';
import store from '@/store/index';
import { PFX, SRM_FILE_PRE } from '../../constant/constant.js';
const tenantCode = store.getters.currentTenant.tenantCode;

const costName = {
// 获取列表
    get(params) {
        params.tenantCode = tenantCode;
        return request({
            url: `${PFX}/contract/contractWarningTasks/selectPage`,
            method: 'post',
            data: params
        });
    },
    // 导出数据
    export(params) {
        params.tenantCode = tenantCode;
        return request({
            url: `${SRM_FILE_PRE}/contract/exportContractWarningTasks`,
            method: 'post',
            data: params,
            responseType: 'arraybuffer'
        });
    },
    // mip iframe链接接口
    getMipUrl (params) {
        return request({
            url: `${PFX}/contract/createContractWarningTaskIFlow`,
            method: 'post',
            data: params
        });
    },
    // 查询mip流程
    queryOneInstance  (params) {
        return request({
            url: `${PFX}/contract/getContractWarningTaskIFlow?contractCode=${params.contractCode}&tenantCode=${tenantCode}`,
            method: 'get'
        }).then(res => res);
    },
    // 提交mip流程
    createProcess (params) {
        return request({
            url: `/api-iflow/approveProcess?tenantCode=${params.tenantCode}&appCode=${params.fdTemplateId}`,
            method: 'post',
            data: params
        }).then(res => res);
    },
    // 获取合同预警待办任务
    queryContractWarningPeddingTask(params) {
        return request({
            url: `${PFX}/contract/contractWarningTask/list`,
            method: 'post',
            data: params
        }).then(res => res);
    },
    // 保存合同预警待办任务
    saveContractWarningTask(params) {
        return request({
            url: `${PFX}/contract/contractWarningTask/save`,
            method: 'post',
            data: params
        }).then(res => res);
    },
    // 关闭合同预警待办任务
    closeContractWarningTask(params) {
        return request({
            url: `${PFX}/contract/contractWarningTask/close`,
            method: 'post',
            data: params
        }).then(res => res);
    },
    // 保存合同预警信息
    contractWarningTaskEdit(data) {
        return request({
            url: `${PFX}/contract/contractWarningTask/edit`,
            method: 'post',
            data
        }).then(res => res);
    },
    // 待办详情
    contractWarningTasksDetail(data) {
        return request({
            url: `${PFX}/contract/contractWarningTask/detail`,
            method: 'post',
            data
        }).then(res => res);
    },
    // 关闭待办
    contractWarningTaskClose(params) {
        return request({
            url: `${PFX}/contract/contractWarningTask/close`,
            method: 'post',
            data: params
        }).then(res => res);
    },
    //下载模版
    downloadTemplate(data) {
        return request({
            url: `${SRM_FILE_PRE}/insurance/downloadTemplate?fileName=contractWarningTask.xlsx`,
            method: 'post',
            responseType: 'arraybuffer',
        }).then(res => {
            return res
        });
    },
    // 推送待办人
    pushBacklog (data) {
        return request({
            url: `${PFX}/contract/contractWarningTask/pushBacklog`,
            method: 'post',
            data,
        })
    }
};
export default costName;
